<template>
    <div class="mx-3">
      <h2 class="px-5 py-5">{{ $t('Lessons Report') }}</h2>
      <v-row class="px-10 py-1">
        <v-col md="3">
          <v-text-field   :label="$t('hr.time.from-date')" type="date" 
                            v-model="filters.from" clearable>
          </v-text-field>
        </v-col>
        <v-col md="3">
          <v-text-field   :label="$t('hr.time.to-date')" type="date" 
                            v-model="filters.to" clearable>
          </v-text-field>
        </v-col>
        <v-col md="3">
          <v-autocomplete v-model="filters.teacher_id" :items="childrens" item-text="name" item-value="id"
            @keypress="fetchTeachers($event)" :loading="childrensLoading"
            :label="$t('teacher name')" clearable></v-autocomplete>
        </v-col>
        <v-col md="3">
            <v-autocomplete 
          v-model="filters.id"
            :label="$t('lesson title')"
            clearable :items="lessons" :loading="childrensLoading" color="#757575" item-text="title"
            item-value="id"  @keypress="fetchlessons($event)"
            >
          </v-autocomplete>
        </v-col>
        <v-col md="3">
            <v-autocomplete 
          v-model="filters.lecture_id"
            :label="$t('lecture title')"
            clearable :items="lectures" :loading="childrensLoading" color="#757575" item-text="title"
            item-value="id"  @keypress="fetchLectures($event)"
            >
          </v-autocomplete>
        </v-col>
        <v-col md="2">
            <v-autocomplete
              color="#757575"
              :loading="eduClassesLoading"
              item-text="name"
              item-value="id"
              :label="$t('educitional class')"
              v-model="filters.edu_class"
              :items="eduClasses"
              clearable
            ></v-autocomplete>
        </v-col>
        <v-col md="2">
        <v-autocomplete
                color="#757575"
                item-text="name"
                item-value="id"
                :loading="gradesLoading"
                :label="$t('class')"
                v-model="filters.grade"
                :items="grades"
                clearable
            ></v-autocomplete>
          </v-col>
          <v-col md="2">
            <v-autocomplete
                color="#757575" 
                :label="$t('Group By')"
                :items="group_by"
                item-text="name"
                item-value="value"
                v-model="filters.group_by"
                
              ></v-autocomplete>
          </v-col>
          <v-col md="2">

          </v-col>

        <v-col md="3" class="mb-3 py-0">
          <v-btn color="green" dark block @click="getAll(1)">{{ $t('search') }}</v-btn>
        </v-col>
        <v-col md="3" class="mb-3 py-0">
          <v-btn color="red" dark block @click="clearFilter">{{ $t('Delete Search') }}</v-btn>
        </v-col>
        <v-col md="3" class="mb-3 py-0">
          <v-btn color="blue" dark block  @click="exportToExcel(filters)"
            >{{ $t('hr.time.export') }}
            </v-btn>
        </v-col>
      </v-row>
  


      <v-container id="regular-tables" fluid tag="section">
      <v-simple-table :dark="$store.state.isDarkMode">
        <thead class="table-heading" v-if="!loading">
          <tr>
            <th v-for="(name, i) in tableHeaders" :key="i">
              {{ $t(name) }}
            </th>
          </tr>
        </thead>
        <div class="table__spinnerWrapper" v-if="loading">
          <app-spinner></app-spinner>
        </div>
        <v-fade-transition mode="out-in" :group="true" tag="tbody" v-if="!loading">
          <template  v-for="data in tableItems" >
            <tr :key="data.uid" style=" background: var(--group-by-col)">
              
              <th colspan="8" style=" border: 0; font-size: 1rem">
                <span v-if="data.key"> {{ data.key }} </span>
              </th>
              
            </tr>
            <tr v-for="(item, idx) in data.value" :key="idx">
              <td>{{ item.id }}</td>
              <td>{{ item.date }}</td>
              <td>{{ item.title }}</td>
              <td>{{ item.teacher }}</td>
              <td>{{ item.edu_class }}</td>
              <td>{{ item.lecture }}</td>
              <td>{{ item.homeworks_count }}</td>
              <td>{{ item.attachments_count }}</td>
              
            </tr>
          </template>
        </v-fade-transition>
      </v-simple-table>
      <div class="d-flex justify-end mt-5">
        <v-row>
          <v-col md="5 ">
            <v-switch
              @change="goToAll"    
              v-model="is_all"
              color="green"
              :label="$t('Show All')"
            ></v-switch>
          </v-col>
        <app-pagination v-if="(!loading & (paginated))" :disable-pagination="!paginated" :totalPages="total" :page="page"
          @PaginationValue="applyPagination($event)"></app-pagination>
        </v-row>
      </div>
    </v-container>
      <!-- <v-data-table 
        :headers="headers"
        :loading="loading"
        :items="tableItems"
        class="elevation-1 px-10"
        hide-default-footer
        :items-per-page="10"
      >
        <template v-slot:item.actions="{ item }">
          
        </template>
      </v-data-table>
      <v-pagination
        v-if="!loading && tableItems.length"
        @input="getAll"
        v-model="page"
        :length="Math.ceil(total / 10)"
      ></v-pagination>-->
    </div> 
  </template>
  
  <script>
  import { meal } from "../../../../store/auth";
  import axios from 'axios'
  import i18n from '@/i18n';
  import debounce from "../../../../helpers/debounce";
  import spinner from "../../../../components/base/spinner.vue";
  import pagination from "../../../../components/base/pagination.vue";
import { saveAs } from 'file-saver';

  
  export default {
    components: {
    appSpinner: spinner,
    appPagination: pagination,
  },
    data: () => ({
      is_all: false,
      paginated: true,
      grades: null,
      gradesLoading: false,
      eduClasses: null,
      eduClassesLoading: false,
      childrens: null,
      lectures: null,
      lessons: null,
      childrensLoading: false,
      tableItems: [],
      meal,
      mealSearch: null,
      loading: false,
      page: 1,
      total: 1,
      tableHeaders: ["id","date", "title", "teacher", "educitional class", "lecture", "homeworks count", "attachments count"],
      // headers: [  
      //   { text: i18n.t("name"), value: "student" },
      //   { text: i18n.t('class'), value: "grade" },
      //   { text: i18n.t('educitional class'), value: "edu_class" },
      //   { text: i18n.t('Absent Type'), value: "type" },
      //   // { text: i18n.t('total credit'), value: "day" },
      //   { text: i18n.t('date'), value: "date" },
      //   { text: i18n.t('hr.employee.note'), value: "note" },
      // ],
      items: [],
      status: [
        {
          name: "مسلمة",
          value: "FULL",
        },
        {
          name: "غير مسلمة",
          value: "ZERO",
        },
        {
          name: "مسلمة جزئية",
          value: "PART",
        },
      ],
      group_by: [
        {
          name: "المادة",
          value: "subject",
        },
        {
          name: "المعلم",
          value: "teacher",
        },
        {
          name: "الشعبة",
          value: "edu_class",
        },
        {
          name: "محاضرة",
          value: "lecture",
        },
        {
          name: "التاريخ",
          value: "date",
        },
        {
          name: "الوحدة",
          value: "unit",
        },
      ],
      meal_group: null,
      filters: {
        teacher_id: null,
        title: null,
        lecture_id: null,
        id: null,
        edu_class_id: null,
        grade: null,
        from: null,
        to: null,
        subject_id: null,
        group_by: "edu_class",
      },
    }),
    computed: {
    mealItems() {
      return meal.mealData;
    },
  },
  watch:{
    mealSearch(val) {
      if ((val != "") & (val != null)) {
        meal.getMealsName(val);
      } else {
        meal.mealData = [];
      }
    },
  },
    methods: {
      goToAll(){
      if(this.is_all) {
        this.paginated = false;
      } else { this.paginated = true; }
      this.getAll();
    },
      async fetchEduClasses() {
      try {
        this.eduClassesLoading = true;
        const eduClasses = await axios.get("/edu-class",{
          params: {
            paginated: false,
          }
        });
        this.eduClasses = eduClasses.data.classes;
      } catch (err) {
      } finally {
        this.eduClassesLoading = false;
      }
    },
    async fetchTeachers(searchQuery) {
      debounce(async () => {
        let searchValue = searchQuery.target.value;
        this.childrensLoading = true;
        if (!searchValue) return;
        try {
          const searchResult = await axios.get("/teacher", {
            params: {
              name: searchValue,
            },
          });
          this.childrens = searchResult.data.teachers;
          
        } catch (err) {
          console.log("err", err);
        } finally {
          this.childrensLoading = false;
        }
      }, 1000)();
    },
    async fetchlessons(searchQuery) {
      debounce(async () => {
        let searchValue = searchQuery.target.value;
        this.childrensLoading = true;
        if (!searchValue) return;
        try {
          const searchResult = await axios.get("/lesson", {
            params: {
              title: searchValue,
            },
          });
          this.lessons = searchResult.data.lessons;
          
        } catch (err) {
          console.log("err", err);
        } finally {
          this.childrensLoading = false;
        }
      }, 1000)();
    },
    async fetchLectures(searchQuery) {
      debounce(async () => {
        let searchValue = searchQuery.target.value;
        this.childrensLoading = true;
        if (!searchValue) return;
        try {
          const searchResult = await axios.get("/lecture", {
            params: {
              title: searchValue,
            },
          });
          this.lectures = searchResult.data.lectures;
          
        } catch (err) {
          console.log("err", err);
        } finally {
          this.childrensLoading = false;
        }
      }, 1000)();
    },
     async exportToExcel(queryParams){
         
          try {
     
      const excel = await axios.get(`/lesson/export`, {
        params: {
          ...queryParams,
          
        },
        responseType: 'blob'
      });
      saveAs(excel.data)
      

    } catch (err) {
      console.log('err', err);
    } finally {
      
    }
      
      },
   
      clearFilter() {
        this.filters.lecture_id =  undefined;
        this.id = undefined;
        this.filters.edu_class_id = undefined;
        this.filters.from = undefined;
        this.filters.to = undefined;
        this.filters.title = undefined; 
        this.filters.grade = undefined;
        this.filters.teacher_id = undefined;
        this.filters.subject_id = undefined;
        this.page = 1;
        this.getAll();
      },
   
      async getAll() {
        try {
         
          const filterTemp = {};
          Object.keys(this.filters).forEach((key) => {
            if (this.filters[key]) filterTemp[key] = this.filters[key];
          });
          this.loading = true;
          
          const res = await axios.get("/lesson/report", {
            params: {
              size: 10,
              page: this.page,
              paginated: this.paginated,
              ...filterTemp,
            },
          });
          const arr= Array.from(res.data.data)
          if(Array.isArray(arr))
          {
            console.log(arr);
            this.tableItems = arr.map((el) => {
              
              return {
                ...el,
                
              };
            });
          }
            console.log(res.data.data);
            this.tableItems.forEach((item) => {
          item.uid = this.$uuid.v1();
        });
          this.total = res.data.total;
          this.page = res.data.current_page;
        } finally {
          this.loading = false;
        }
      },
      applyPagination(paginationValue) {
      this.page = paginationValue;
      this.getAll();
    },
      async groupAc() {
            try {
          const searchResult = await axios.get(
            "/meal-group"
          );
          this.meal_group = searchResult.data.data;
        } catch (err) {
          console.log("err", err);
        } 
      },
 
    },
    async created() {
      this.getAll();
      this.groupAc();
      this.fetchEduClasses();
      try {
      this.gradesLoading = true;
      const response = await axios.get("/grade", {
        params: {
          size: 100000,
        },
      });
      this.grades = response.data.grades;
    } catch (err) {
      console.log("err", err);
    } finally {
      this.gradesLoading = false;
    }
      
    },
  };
  </script>
  
  <style></style>
  